import ExceptionHandling from './ExceptionHandling.js'
import { useStore, ActionTypes } from "../store";
import instance from './index';
import UtilityOptions from "../mixins/UtilityOptions";
import {  mixins } from "vue-class-component";

export default class PermissionsService {
	// extends mixins(UtilityOptions){

	// can($permission_name){
	// 	return this.can($permission_name);
	// }
	

	get userPermission() {
		const store = useStore();
		const p = JSON.parse(store.getters.gerUserPermissions);
		return p;
	}

    can(permission) {
        const pL = this.userPermission;
        const f = pL.filter(e => e.name == permission);

        let res = false;

        if (f.length > 0) {
            res = true;
        }

        return res;
    }
}